<template>
    <div class="w-full bg-[#1a2a4a] py-[30px] sm:py-[56px] px-[20px] sm:px-[46px] rounded-xl">
        <form @submit.prevent="submit" class="grid grid-cols-1 gap-4">
            <div>
                <input
                    id="fields-name"
                    type="text"
                    v-model="fields.name"
                    placeholder="Name*"
                    class="w-full border border-white/30 bg-white rounded px-4 py-3 text-sm font-body text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white"
                    :class="{ 'border-red-500': errors.name }"
                />
                <div v-if="errors && errors.name" class="text-danger mt-1">{{ errors.name[0] }}</div>
            </div>

            <div>
                <input
                    id="fields-email"
                    type="email"
                    v-model="fields.email"
                    placeholder="Email*"
                    class="w-full border border-white/30 bg-white rounded px-4 py-3 text-sm font-body text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white"
                    :class="{ 'border-red-500': errors.email }"
                />
                <div v-if="errors && errors.email" class="text-danger mt-1">{{ errors.email[0] }}</div>
            </div>

            <div>
                <input
                    id="fields-contact"
                    type="tel"
                    v-model="fields.contact"
                    placeholder="Contact Number"
                    class="w-full border border-white/30 bg-white rounded px-4 py-3 text-sm font-body text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white"
                    :class="{ 'border-red-500': errors.contact }"
                />
                <div v-if="errors && errors.contact" class="text-danger mt-1">{{ errors.contact[0] }}</div>
            </div>

            <div>
                <textarea
                    id="fields-message"
                    rows="5"
                    v-model="fields.message"
                    placeholder="Message"
                    class="w-full border border-white/30 bg-white rounded px-4 py-3 text-sm font-body text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white resize-none"
                    :class="{ 'border-red-500': errors.message }"
                ></textarea>
                <div v-if="errors && errors.message" class="text-danger mt-1">{{ errors.message[0] }}</div>
            </div>

            <div>
                <div class="text-danger mb-1">{{ recaptchaError ? 'Verification*' : '' }}</div>
                <div recaptcha-el></div>
                <div class="text-danger">{{ recaptchaError }}</div>
            </div>

            <div>
                <button
                    ref="btnSubmit"
                    type="submit"
                    class="w-full bg-blue-300 text-white font-body text-base font-semibold py-3 rounded hover:opacity-90 transition-opacity uppercase"
                >
                    Submit Enquiry
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import hapiMixins from "hapiform-with-recaptcha";

    export default {
        mixins: [hapiMixins],
        data() {
            return {
                hapiformID: "9b977db5-5981-4507-8f37-51baf43162c0",
                redirectTo: "/thank-you/",
                recaptchaDisabled: false,
                fields: {
                    name: "",
                    email: "",
                    contact: "",
                    message: "",
                },
            };
        },
    };
</script>

<style scoped>
    .text-danger {
        color: #ef4444;
        font-size: 11px;
    }
</style>